import React, { useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, ButtonBase, Collapse, Stack, Typography } from '@mui/material';

export type CollapsibleListFiltersProps = {
  /** Toolbar actions aligned to the right (e.g. refresh, create). */
  actions?: React.ReactNode;
  children?: React.ReactNode;
  defaultOpen?: boolean;
  filterToggleTestId?: string;
};

/** Collapsible filter panel with optional toolbar actions on the right. */
export function CollapsibleListFilters({
  actions,
  children,
  defaultOpen = false,
  filterToggleTestId,
}: CollapsibleListFiltersProps) {
  const [filtersOpen, setFiltersOpen] = useState(defaultOpen);
  const hasFilters = children != null;

  return (
    <Stack spacing={1.5} sx={{ mb: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={hasFilters ? 'space-between' : 'flex-end'}
        flexWrap="wrap"
        gap={1}
      >
        {hasFilters ? (
          <ButtonBase
            onClick={() => setFiltersOpen((open) => !open)}
            aria-expanded={filtersOpen}
            aria-label={filtersOpen ? 'Sembunyikan filter' : 'Tampilkan filter'}
            data-testid={filterToggleTestId}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              borderRadius: 1,
              px: 0.5,
              py: 0.25,
              color: 'text.secondary',
              '&:hover': { bgcolor: 'action.hover' },
            }}
          >
            <Typography variant="subtitle2" component="span" sx={{ fontWeight: 600 }}>
              Filter
            </Typography>
            {filtersOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </ButtonBase>
        ) : (
          <Box sx={{ flex: 1 }} />
        )}
        {actions ? (
          <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1}>
            {actions}
          </Stack>
        ) : null}
      </Stack>
      {hasFilters ? (
        <Collapse in={filtersOpen} timeout="auto">
          <Stack spacing={1.5}>{children}</Stack>
        </Collapse>
      ) : null}
    </Stack>
  );
}
